<template>
    <div v-if="!loadingPage" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">انبارگردانی</h3>
            <div v-if="isAdminIdentityVerified" class="d-flex justify-content-md-end justify-content-center mb-2">
                <b-button @click="showModalCreate" :disabled="!materials.length || !warehouses.length" variant="primary"
                    class="px-2">
                    ثبت انبارگردانی
                </b-button>
            </div>
        </div>
        <div v-if="isAdminIdentityVerified">
            <b-row class="mb-2 mb-md-50">
                <b-col xl="3" lg="4">
                    <b-form-group label="شماره انبارگردانی">
                        <b-form-input dir="ltr" type="number" v-model="parameters.number" autocomplete="off"
                            class="text-center"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="4" class="mt-25">
                    <b-form-group label="انبار" label-for="warehouseId">
                        <v-select v-model="parameters.warehouseId" :searchable="false" id="warehouseId" dir="rtl"
                            :options="warehouseParameter" autocomplete="off" class="bg-white"
                            style="border-radius: 6px;" :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="2" md="4" class="mt-md-2 mt-50">
                    <b-button variant="info" @click="getWarehousingStockTakings" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>جستجو</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <b-card class="p-0" no-body>
                <b-overlay v-if="stockTakings.length" :show="loading" variant="transparent" opacity="1" blur="3px"
                    rounded="sm">
                    <b-table responsive :items="stockTakings" :fields="fields" class="mb-0" striped>
                        <template #cell(details)="data">
                            <b-spinner v-if="loadingbuttons[data.index]" variant="info" small></b-spinner>
                            <feather-icon v-else @click="showDetails(data.item.id, data.index, data.item.isFinalized)"
                                size="20" icon="InfoIcon" class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(warehouse)="data">
                            {{ data.item.warehouse ? data.item.warehouse.name : '-' }}
                        </template>
                        <template #cell(number)="data">
                            {{ data.item.number ? data.item.number : '-' }}
                        </template>
                        <template #cell(isFinalized)="data">
                            <b-badge :variant="data.item.isFinalized ? 'light-success' : 'light-warning'" pill>
                                {{ data.item.isFinalized ? 'تایید شده' : 'در انتظار تایید' }}
                            </b-badge>
                        </template>
                        <template #cell(lastModifiedByUser)="data">
                            {{ data.item.lastModifiedByUser ? `${data.item.lastModifiedByUser.firstName}
                            ${data.item.lastModifiedByUser.lastName}` : '-' }}
                        </template>
                        <template #cell(hasConflict)="data">
                            <span>
                                {{ data.item.hasConflict ? 'مغایرت دارد' : 'مغایرت ندارد' }}
                            </span>
                        </template>
                        <template #cell(finalizedByUser)="data">
                            {{ data.item.finalizedByUser ? `${data.item.finalizedByUser.firstName}
                            ${data.item.finalizedByUser.lastName}` : '-' }}
                        </template>
                        <template #cell(finalizedAt)="data">
                            <div v-if="data.item.finalizedAt">
                                <span>
                                    {{ new Date(data.item.finalizedAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.finalizedAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </div>
                            <div v-else>
                                -
                            </div>
                        </template>
                        <template #cell(createdAt)="data">
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </template>
                    </b-table>
                </b-overlay>
                <div v-else class="text-center py-5">
                    موردی وجود ندارد
                </div>
            </b-card>
            <b-pagination align="center" @input="getWarehousingStockTakings" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal create ------------------------------->
        <b-modal id="warehousing-stockTakings" title="ثبت انبارگردانی" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <validation-observer ref="warehousingStockTakingsValidation">
                <b-form @submit.prevent class="p-1">
                    <b-row v-for="(item, index) in formItems" :key="`item_${index}`" class="mb-2 mb-lg-50 mb-md-2">
                        <b-col xl="4" lg="4">
                            <b-form-group label="ماده اولیه (کالا)">
                                <validation-provider #default="{ errors }" name="ماده اولیه" rules="required"
                                    :vid="`rawMaterial_${index}`">
                                    <v-select v-model="item.rawMaterial" :searchable="false" dir="rtl"
                                        @input="item.displayUnit = item.rawMaterial.unit" :reduce="(value) => value"
                                        class="bg-white" :class="errors.length > 0 ? 'border-danger' : null"
                                        style="border-radius: 6px;" label="name" :clearable="false"
                                        :options="materials">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="3" lg="3">
                            <b-form-group label="واحد اندازه‌گیری">
                                <validation-provider #default="{ errors }" name="واحد اندازه‌گیری" rules="required"
                                    :vid="`displayUnit_${index}`">
                                    <v-select v-model="item.displayUnit" :searchable="false" dir="rtl"
                                        :disabled="!item.rawMaterial" :reduce="(value) => value.id" class="bg-white"
                                        :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                        label="name" :clearable="false" :options="getUnits(item.rawMaterial)">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="3" lg="3">
                            <b-form-group label="مقدار">
                                <validation-provider #default="{ errors }" name="مقدار" rules="required"
                                    :vid="`countedQuantity_${index}`">
                                    <b-form-input dir="ltr" type="number" v-model="item.countedQuantity"
                                        inputmode="numeric" :class="errors.length > 0 ? 'border-danger' : null"
                                        autocomplete="off" class="text-center"></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="2" lg="2" class="mt-2 pt-0 pt-lg-25">
                            <b-button variant="danger" @click="deleteRawMaterialItems(item)" class="w-100"
                                :disabled="formItems.length == 1">
                                <feather-icon icon="Trash2Icon" size="18" />
                            </b-button>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end mt-50 pb-50">
                        <b-button variant="info" @click="addRawMaterialItems">
                            اضافه کردن
                        </b-button>
                    </div>
                    <hr>
                    <b-row class="mt-2">
                        <!------------ type ------------>
                        <b-col md="12">
                            <b-form-group label="انبار" label-for="typeId" class="text-center">
                                <validation-provider #default="{ errors }" name="انبار" rules="required">
                                    <v-select v-model="form.warehouseId" :searchable="false" dir="rtl"
                                        :reduce="(value) => value.id" class="warehouse-select bg-white"
                                        :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                        label="name" :clearable="false" :options="warehouses">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!-- description -->
                        <b-col md="12">
                            <b-form-group label="توضیحات" label-for="descriptionId" class="text-center">
                                <b-form-textarea rows="2" no-resize autocomplete="off" dir="rtl" id="descriptionId"
                                    v-model="form.description" name="description"></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="mt-2">
                        <b-button type="submit" variant="primary" @click="createWarehousingStockTakings"
                            :disabled="loadingButton"
                            class="w-100 mt-75 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>ثبت انبارگردانی</span>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </b-modal>


        <!------------------------------- modal edit ------------------------------->
        <b-modal id="warehousing-stockTakings-edit" title="ویرایش انبارگردانی" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <validation-observer ref="warehousingStockTakingsValidation">
                <b-form @submit.prevent class="p-1">
                    <b-row v-for="(item, index) in formItems" :key="`item_${index}`" class="mb-2 mb-lg-50 mb-md-2">
                        <b-col xl="4" lg="4">
                            <b-form-group label="ماده اولیه (کالا)">
                                <validation-provider #default="{ errors }" name="ماده اولیه" rules="required"
                                    :vid="`rawMaterial${index}`">
                                    <v-select v-model="item.rawMaterial" :searchable="false" dir="rtl"
                                        @input="item.displayUnit = item.rawMaterial.unit" :reduce="(value) => value"
                                        class="bg-white" :class="errors.length > 0 ? 'border-danger' : null"
                                        style="border-radius: 6px;" label="name" :clearable="false"
                                        :options="materials">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="3" lg="3">
                            <b-form-group label="واحد اندازه‌گیری">
                                <validation-provider #default="{ errors }" name="واحد اندازه‌گیری" rules="required"
                                    :vid="`displayUnit${index}`">
                                    <v-select v-model="item.displayUnit" :searchable="false" dir="rtl"
                                        :disabled="!item.rawMaterial" :reduce="(value) => value.id" class="bg-white"
                                        :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                        label="name" :clearable="false" :options="getUnits(item.rawMaterial)">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="3" lg="3">
                            <b-form-group label="مقدار">
                                <validation-provider #default="{ errors }" name="مقدار" rules="required"
                                    :vid="`countedQuantity${index}`">
                                    <b-form-input dir="ltr" type="number" v-model="item.countedQuantity"
                                        inputmode="numeric" :class="errors.length > 0 ? 'border-danger' : null"
                                        autocomplete="off" class="text-center"></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="2" lg="2" class="mt-2 pt-0 pt-lg-25">
                            <b-button variant="danger" @click="deleteRawMaterialItems(item)" class="w-100"
                                :disabled="formItems.length == 1">
                                <feather-icon icon="Trash2Icon" size="18" />
                            </b-button>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end mt-50 pb-50">
                        <b-button variant="info" @click="addRawMaterialItems">
                            اضافه کردن
                        </b-button>
                    </div>
                    <hr>
                    <b-row class="mt-2">
                        <!------------ type ------------>
                        <b-col md="12">
                            <b-form-group label="انبار" label-for="typeId" class="text-center">
                                <validation-provider #default="{ errors }" name="انبار" rules="required">
                                    <v-select v-model="form.warehouseId" :searchable="false" dir="rtl"
                                        :reduce="(value) => value.id" class="warehouse-select bg-white"
                                        :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                        label="name" :clearable="false" :options="warehouses">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!-- description -->
                        <b-col md="12">
                            <b-form-group label="توضیحات" label-for="descriptionId" class="text-center">
                                <b-form-textarea rows="2" no-resize autocomplete="off" dir="rtl" id="descriptionId"
                                    v-model="form.description" name="description"></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="mt-2">
                        <b-button type="submit" variant="primary" @click="editWarehousingStockTakings"
                            :disabled="loadingButton"
                            class="w-100 mt-75 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>ویرایش انبارگردانی</span>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </b-modal>


        <!------------------------------- modal warehousing stockTakings detail ------------------------------->
        <b-modal id="warehousing-stockTakings-detail" title="جزئیات انبارگردانی" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <div>
                <stockTakingDetail :stockTakingDetails="stockTakingDetails" />

                <b-row class="pt-75">
                    <b-col md="4">
                        <b-button @click="$bvModal.show('delete-stockTakings-modal')"
                            :disabled="stockTakingIsFinalized || loadingButton" class="w-100 mb-1" variant="danger">
                            حذف
                        </b-button>
                    </b-col>
                    <b-col md="4">
                        <b-button @click="showModalEdit" :disabled="stockTakingIsFinalized || loadingButton"
                            class="w-100 mb-1" variant="primary">
                            ویرایش
                        </b-button>
                    </b-col>
                    <b-col md="4">
                        <b-button type="submit" variant="success" @click="warehousingStockTakingsFinalize"
                            :disabled="stockTakingIsFinalized || loadingButton"
                            class="w-100 d-flex align-items-center justify-content-center mb-1">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>تایید</span>
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <!-------------------------------------- modal delete stockTakings -------------------------------------->
        <b-modal id="delete-stockTakings-modal" title="حذف گزارش انبارگردانی" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <div class="p-1">
                <h5 class="text-center text-danger mb-3 mt-1">
                    آیا از حذف این گزارش مطمئن هستید؟
                </h5>
                <div class="d-flex align-items-center">
                    <b-button @click="$bvModal.hide('delete-stockTakings-modal')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button type="submit" variant="danger" @click="deleteWarehousingStockTakings"
                        :disabled="loadingButton" class="w-50 d-flex align-items-center justify-content-center">
                        <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                        <span>حذف</span>
                    </b-button>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import stockTakingDetail from '@/@core/components/stock-taking-detail/index.vue';
import Cleave from 'vue-cleave-component'
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BBadge,
        vSelect,
        stockTakingDetail
    },
    computed: {
        unit_management() {
            return (status) => {
                if (status == 1) {
                    return 'کیلوگرم'
                }
                if (status == 2) {
                    return 'لیتر'
                }
                if (status == 3) {
                    return 'عدد'
                }
            }
        },
        getUnits() {
            return (rawMaterial) => {
                if (!rawMaterial) return [];
                if (rawMaterial.unit === 1) return this.unitKilogram;
                if (rawMaterial.unit === 2) return this.unitLiter;
                return this.unitNumber;
            }
        },
    },
    mixins: [accessHandling],
    data() {
        return {
            required,
            loadingPage: true,
            loading: false,
            loadingbuttons: [],
            loadingButton: false,
            isAdminIdentityVerified: false,
            materials: [],
            warehouses: [],
            warehouseParameter: [],
            stockTakings: [],
            stockTakingDetails: {},
            currentDate: '',
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },
            unitKilogram: [
                {
                    name: 'گرم',
                    id: 1,
                },
                {
                    name: 'کیلوگرم',
                    id: 100,
                },
            ],
            unitLiter: [
                {
                    name: 'میلی‌لیتر',
                    id: 2,

                },
                {
                    name: 'لیتر',
                    id: 101,
                },
            ],
            unitNumber: [
                {
                    name: 'عدد',
                    id: 3,

                },
            ],
            fields: [
                {
                    key: 'number',
                    label: 'شماره انبارگردانی',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ ثبت',
                },
                {
                    key: 'warehouse',
                    label: 'نام انبار',
                },
                {
                    key: 'hasConflict',
                    label: 'وضعیت مغایرت',
                },
                {
                    key: 'lastModifiedByUser',
                    label: 'ثبت یا ویرایش‌ کننده',
                },
                {
                    key: 'isFinalized',
                    label: 'وضعیت انبارگردانی',
                },
                {
                    key: 'finalizedAt',
                    label: 'تاریخ تایید',
                },
                {
                    key: 'finalizedByUser',
                    label: 'تایید کننده',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                number: null,
                warehouseId: null,
            },
            parametersMaterials: {
                pageIndex: 1,
                pageSize: 90,
            },
            parametersWarehouses: {
                pageIndex: 1,
                pageSize: 90,
            },
            storeId: null,
            formItems: [],
            stockTakingId: null,
            stockTakingIsFinalized: true,
            form: {
                items: [],
                warehouseId: null,
                description: null,
            },
        }
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        deleteRawMaterialItems(value) {
            this.formItems = this.formItems.filter(item => item !== value)
        },
        addRawMaterialItems() {
            this.formItems.push({
                rawMaterial: null,
                countedQuantity: null,
                displayUnit: null,
            })
        },
        showDetails(id, index, isFinalized) {
            this.$set(this.loadingbuttons, index, true);
            this.stockTakingId = id
            this.stockTakingIsFinalized = isFinalized
            storeService.getWarehousingStockTakingsById(this.storeId, id).then(({ data }) => {
                this.stockTakingDetails = data
                this.$set(this.loadingbuttons, index, false);
                this.$bvModal.show('warehousing-stockTakings-detail')
            })
                .catch((err) => {
                    this.$set(this.loadingbuttons, index, false);
                });
        },
        showModalCreate() {
            if (this.accessHandling('employee', 'stock_takings_create')) {
                this.form.warehouseId = null
                this.form.items = []
                this.formItems = [{
                    rawMaterial: null,
                    countedQuantity: null,
                    displayUnit: null,
                }]
                this.form.description = null
                this.$bvModal.show('warehousing-stockTakings')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalEdit() {
            if (this.accessHandling('employee', 'stock_takings_edit_delete')) {
                this.form.warehouseId = this.stockTakingDetails.warehouse.id
                this.formItems = []
                this.formItems = this.stockTakingDetails.items.map(item => ({
                    rawMaterial: { id: item.id, unit: item.unit, name: item.name },
                    countedQuantity: [101, 100].includes(item.displayUnit) ? Number(item.countedQuantity) / 1000 : Number(item.countedQuantity),
                    displayUnit: item.displayUnit
                }))
                this.form.description = this.stockTakingDetails.description
                this.form.items = []
                this.$bvModal.hide('warehousing-stockTakings-detail')
                this.$bvModal.show('warehousing-stockTakings-edit')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        editWarehousingStockTakings() {
            this.$refs.warehousingStockTakingsValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    this.form.items = this.formItems.map(item => ({
                        rawMaterialId: item.rawMaterial.id,
                        countedQuantity: [101, 100].includes(item.displayUnit) ? Number(item.countedQuantity) * 1000 : Number(item.countedQuantity),
                        displayUnit: item.displayUnit
                    }))
                    storeService.editWarehousingStockTakings(this.storeId, this.stockTakingId, this.form).then(({ data }) => {
                        this.$refs.warehousingStockTakingsValidation.reset();
                        this.$notif({ type: 'success', title: 'انبارگردانی با موفقیت ویرایش شد' });
                        this.$bvModal.hide('warehousing-stockTakings-edit')
                        this.getWarehousingStockTakings()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        createWarehousingStockTakings() {
            this.$refs.warehousingStockTakingsValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    this.form.items = this.formItems.map(item => ({
                        rawMaterialId: item.rawMaterial.id,
                        countedQuantity: [101, 100].includes(item.displayUnit) ? Number(item.countedQuantity) * 1000 : Number(item.countedQuantity),
                        displayUnit: item.displayUnit
                    }))
                    storeService.warehousingStockTakings(this.storeId, this.form).then(({ data }) => {
                        this.$refs.warehousingStockTakingsValidation.reset();
                        this.$notif({ type: 'success', title: 'انبارگردانی با موفقیت ثبت شد' });
                        this.$bvModal.hide('warehousing-stockTakings')
                        this.getWarehousingStockTakings()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        warehousingStockTakingsFinalize() {
            if (this.accessHandling('employee', 'stock_takings_approve')) {
                this.loadingButton = true
                storeService.warehousingStockTakingsFinalize(this.storeId, this.stockTakingId).then(({ data }) => {
                    this.$notif({ type: 'success' });
                    this.$bvModal.hide('warehousing-stockTakings-detail')
                    this.getWarehousingStockTakings()
                })
                    .finally(() => {
                        this.loadingButton = false
                    });
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        deleteWarehousingStockTakings() {
            this.loadingButton = true
            storeService.deleteWarehousingStockTakings(this.storeId, this.stockTakingId).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.$bvModal.hide('delete-stockTakings-modal')
                this.$bvModal.hide('warehousing-stockTakings-detail')
                this.getWarehousingStockTakings()
            })
                .finally(() => {
                    this.loadingButton = false
                });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getWarehousingMaterials();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getWarehousingStockTakings() {
            this.loading = true
            this.loadingbuttons = []
            storeService.getWarehousingStockTakings(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.stockTakings = data.items
                    if (this.stockTakings.length) {
                        this.stockTakings.forEach(obj => {
                            this.loadingbuttons.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.stockTakings = data.items
                        if (this.stockTakings.length) {
                            this.stockTakings.forEach(obj => {
                                this.loadingbuttons.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        getWarehousingMaterials() {
            storeService.getWarehousingMaterials(this.storeId, this.parametersMaterials).then(({ data }) => {
                this.materials = data.items
                this.getWarehousingWarehouses();
            })
        },
        getWarehousingWarehouses() {
            storeService.getWarehousingWarehouses(this.storeId, this.parametersWarehouses).then(({ data }) => {
                this.warehouses = data.items
                this.warehouseParameter = [...data.items]
                this.warehouseParameter.unshift({
                    id: null,
                    name: 'نمایش همه'
                })
                this.getWarehousingStockTakings();
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const today = new Date();
        this.currentDate = this.formatDate2(today);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.warehouse-select .vs__dropdown-menu {
    max-height: 170px;
    overflow-y: auto;
}
</style>